import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InvoiceTemplate from './InvoiceTemplate';

export default function PrintInvoice({ invoice, invoiceItems }) {

    const location = useLocation();
    const navigate = useNavigate();

    const titleState = location.state?.title || 'Invoice';
    const invoiceState = location.state?.invoice;
    const invoiceItemsState = location.state?.invoiceItems;

    useEffect(() => {
        if (invoiceState && invoiceItemsState) {
            // Set page title
            document.title = `Invoice - ${invoiceState.id}`;

            // Small delay to ensure the component is fully rendered
            const timer = setTimeout(() => {
                window.print();
            }, 500);

            // Go back after print completes or user cancels
            const handleAfterPrint = () => {
                navigate(-1);
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                clearTimeout(timer);
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [invoiceState, invoiceItemsState, navigate]);

    // If no invoice data is passed, we can show an error or a placeholder
    if (!invoiceState || !invoiceItemsState) {
        return (
            <div style={{
                padding: '20px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
            }}>
                <h2>No invoice data available for printing.</h2>
                <p>Please navigate to the invoice details page and use the print option there.</p>
                <button onClick={() => window.history.back()}>Go Back</button>
            </div>
        );
    }

    return (
        <div>
            <InvoiceTemplate 
            title={titleState} 
            invoice={invoiceState} 
            invoiceItems={invoiceItemsState} 
            showStatus={false} 
            showPrintedDate={true} />
        </div>
    );
}